import { render } from "./bot-sidebar.vue?vue&type=template&id=42f36ae8"
import script from "./bot-sidebar.vue?vue&type=script&lang=js"
export * from "./bot-sidebar.vue?vue&type=script&lang=js"

import "./bot-sidebar.vue?vue&type=style&index=0&id=42f36ae8&lang=css"
script.render = render

export default script